<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Samples</li>
    </ol>
</nav>

<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center gx-2 gy-2">

                <!-- Page Title -->
                <div class="col-12 col-md-6 col-lg-6">
                    <h5 class="mb-0 text-dark fw-bold">Samples</h5>
                </div>

                <!-- Actions: Add Button + Date Filter -->
                <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-md-end flex-wrap align-items-center gap-2">

                    <!-- Add Button -->
                    @if (userDataService?.roleMatch(['SAMPLE-ADD'])) {
                        <button type="button" class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0" style="width: 25px; height: 25px;" routerLink="/sample/add">
                            <mat-icon fontIcon="add"></mat-icon>
                        </button>
                    }

                    <!-- Date Filter -->
                    <mat-form-field appearance="fill" class="m-0" style="min-width: 240px;" (click)="picker.open()">
                        <mat-label>Filter by Creation Date</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start Date" [(ngModel)]="sampleSearch.startdate" readonly />
                            <input matEndDate placeholder="End Date" [(ngModel)]="sampleSearch.enddate" (dateChange)="getAllSamples(null)" readonly />
                        </mat-date-range-input>
                        <div matSuffix class="d-flex align-items-center gap-1">
                            @if (sampleSearch.startdate || sampleSearch.enddate) {
                                <mat-icon (click)="clearDateRange()" class="clear-icon" style="cursor: pointer;">close</mat-icon>
                            } @else {
                                <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                            }
                        </div>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>

                </div>
            </div>

            <hr class="m-0 p-0">
            <hr class="m-0 p-0">

            <!-- Filter Row -->
            <div class="row align-items-end">

                <!-- Sample Name Filter -->
                <div class="col-12 col-sm-6 col-lg-3">
                    <mat-form-field class="dense w-100">
                        <mat-label>Sample Name</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>

                <!-- Barcode Filter -->
                <div class="col-12 col-sm-6 col-lg-3">
                    <mat-form-field class="dense w-100">
                        <mat-label>Barcode</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.barCode" name="barCode" (input)="onBarCodeInputChange($event)">
                    </mat-form-field>
                </div>

                <!-- Company Filter (only for non-company users) -->
                @if (!isCompanyLoggedIn) {
                    <div class="col-12 col-sm-6 col-lg-3">
                        <ng-select [items]="allCompanies" bindLabel="name" bindValue="_id" placeholder="Select Company" [(ngModel)]="sampleSearch.company" name="company" (change)="sampleFilter($event)">
                        </ng-select>
                    </div>
                }

                <!-- Category Filter -->
                <div class="col-12 col-sm-6 col-lg-3">
                    <ng-select [items]="allCategoriesMini" bindLabel="name" bindValue="_id" placeholder="Select Category" [(ngModel)]="sampleSearch.category" name="category" (change)="sampleFilter($event)">
                    </ng-select>
                </div>
            </div>

            <!-- Sample Table -->

            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered compact-table">
                        <!-- Position Column -->
                        <ng-container matColumnDef="srno">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="company">
                            <th mat-header-cell *matHeaderCellDef> Company </th>
                            <td mat-cell *matCellDef="let element" class="">
                                <!-- {{ element.companyId?.name }} -->
                                <img [src]="getImg(element.companyId?.trimImage)" class="rounded-circle logo-img" alt=""
                                    [title]="element.companyId?.name ">

                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Sample Name </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex align-items-center gap-2">
                                    <!-- Image on the left -->
                                    <img [src]="getImg(element?.sampleImages[0])" class="rounded-circle logo-img"
                                        [alt]="element.companyId?.name" [title]="element.name" />

                                    <!-- Name + Category on the right -->
                                    <div>
                                        <div class="fw-bold " (click)="openModel(element._id)" style="cursor: pointer;">
                                            {{ element.name }}</div>
                                        <small class="text-muted fs-7">{{ element.categoryId.name }}</small>
                                    </div>
                                </div>
                            </td>

                        </ng-container>
                        <ng-container matColumnDef="barcode">
                            <th mat-header-cell *matHeaderCellDef> Bar Code </th>
                            <td mat-cell *matCellDef="let element"> {{element.sampleCode}} </td>
                        </ng-container>

                        <ng-container matColumnDef="totalItems">
                            <th mat-header-cell *matHeaderCellDef>Total Items </th>
                            <td mat-cell *matCellDef="let element"> {{element.totalItems}} </td>
                        </ng-container>
                        <ng-container matColumnDef="leftItems">
                            <th mat-header-cell *matHeaderCellDef> Left Items </th>
                            <td mat-cell *matCellDef="let element"> {{element.leftItems}} </td>
                        </ng-container>


                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap"> Created At </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.createdAt | date:'dd/MM/yyyy' }}<br>
                                <small>{{ element.createdAt | date:'hh:mm a' }}</small>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="isBlocked">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <ng-toggle [value]="!element.isBlocked"
                                    [color]="{ unchecked: '#939da2', checked: '#006B88' }"
                                    (click)="sampleStatus(element)" [width]="30" [height]="15">
                                </ng-toggle>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="preview">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> Preview </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <mat-icon aria-hidden="false" aria-label="visibility icon" fontIcon="visibility"
                                        class="c_btn" (click)="openModel(element._id)">
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        @if (userDataService?.roleMatch(['SAMPLE-ASSIGN'])) {
                        <ng-container matColumnDef="assignSample">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                + Assign <br> Sample
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <i class="bi bi-clipboard-plus c_btn" title="Assign Sample"
                                        [routerLink]="['/sample/assign', element._id]">
                                    </i>
                                </div>
                            </td>
                        </ng-container>
                        }

                        @if(userDataService?.roleMatch(['SAMPLE-EDIT'])){
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
                            <td mat-cell *matCellDef="let element" class="text-center">

                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <mat-icon aria-hidden="false" aria-label="Edit icon" fontIcon="edit" class="c_btn"
                                        [routerLink]="['/sample/edit',element._id]"></mat-icon>
                                </div>
                            </td>
                        </ng-container>
                        }



                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                No data available
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <mat-paginator #paginator [length]="total" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllSamples($event)">
            </mat-paginator>

        </app-card>
    </div>
</div>


<!-- sample detail -->
<div class="modal fade" id="sampleDetailModal" tabindex="-1" aria-labelledby="sampleDetailModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 rounded-3 overflow-hidden">
            <div class="modal-header border-0 p-2">
                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>

            <div class="container-fluid p-0">
                <div class="card border-0 rounded-0">
                    <!-- Header Section -->
                    <div class="card-header bg-gradient-primary text-white p-3">
                        <div class="d-flex flex-wrap justify-content-between align-items-start">
                            <div>
                                <h5 class="fw-semibold text-dark mb-1">{{sampleData?.name}}</h5>
                                <small class="text-dark">{{sampleData?.categoryId.name}}</small>
                                <div class="d-flex flex-wrap gap-2 mt-1">
                                    @if (sampleData?.sampleCode) {
                                    <span class="fw-bold text-dark">{{ getSampleCode(sampleData.sampleCode) }}</span>
                                    <svg #barcodeElement></svg>
                                    }

                                </div>
                            </div>
                            <div class="text-end text-dark small">
                                @if (sampleData?.companyId?.name) {
                                <div><strong>Added by:</strong> {{sampleData.companyId.name}}</div>
                                }
                                @if (sampleData?.createdAt) {
                                <div><strong>Created:</strong> {{sampleData.createdAt | date}}</div>
                                }
                            </div>
                        </div>
                    </div>

                    <!-- Body Section -->
                    <div class="card-body p-3">
                        <div class="row g-3">
                            <!-- Images Gallery -->
                            <div class="col-md-4">
                                @if (sampleData?.sampleImages?.length) {
                                <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
                                    <div class="carousel-inner rounded">
                                        @for (image of sampleData.sampleImages; track image; let i = $index) {
                                        <div class="carousel-item" [class.active]="i === 0">
                                            <img [src]="getImg(image)" class="d-block w-100 img-fluid"
                                                style="height: 300px; object-fit: cover;" alt="Sample Image">
                                        </div>
                                        }
                                    </div>
                                    <button class="carousel-control-prev" type="button"
                                        data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon bg-dark rounded-circle p-2"></span>
                                        <span class="visually-hidden">Previous</span>
                                    </button>
                                    <button class="carousel-control-next" type="button"
                                        data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                                        <span class="carousel-control-next-icon bg-dark rounded-circle p-2"></span>
                                        <span class="visually-hidden">Next</span>
                                    </button>
                                </div>
                                } @else {
                                <div class="bg-light rounded d-flex align-items-center justify-content-center"
                                    style="height: 300px;">
                                    <p class="text-muted mb-0">No images available</p>
                                </div>
                                }

                                @if (sampleData?.videoLink) {
                                <div class="mt-3">
                                    <h6 class="fw-bold mb-2">{{sampleData.videoTitle??"Product Video"}}</h6>
                                    <div class="ratio ratio-16x9">
                                        <iframe [src]="sampleData.videoLink | safeUrl" frameborder="0"
                                            allowfullscreen></iframe>
                                    </div>
                                </div>
                                }
                            </div>

                            <!-- Details Section -->
                            <div class="col-md-7">
                                <!-- Inventory Status -->
                                <div class="row text-center mb-3">
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Total</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.totalItems || 0}}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Available</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.leftItems || 0}}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Assigned</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.assignedItems || 0}}</span>
                                    </div>
                                </div>

                                <!-- Product Details -->
                                <div class="mb-3">
                                    <h6 class="fw-bold border-bottom pb-1">Product Details</h6>

                                    @if (sampleData?.description) {
                                    <div><small class="fw-bold">Description:</small>
                                        <div [innerHTML]="sampleData.description"></div>
                                    </div>
                                    }
                                    @if (sampleData?.aboutSample) {
                                    <div><small class="fw-bold">About Sample:</small>
                                        <div [innerHTML]="sampleData.aboutSample"></div>
                                    </div>
                                    }
                                    @if (sampleData?.ingredients) {
                                    <div><small class="fw-bold">Ingredients:</small>
                                        <div [innerHTML]="sampleData.ingredients"></div>
                                    </div>
                                    }

                                    @if (sampleData?.usageInstructions) {
                                    <div><small class="fw-bold">Usage:</small>
                                        <div [innerHTML]="sampleData.usageInstructions"></div>
                                    </div>
                                    }
                                </div>

                                <!-- Issue Limits -->
                                <div>
                                    <h6 class="fw-bold border-bottom pb-1">Issue Limits</h6>
                                    <div class="row text-center">
                                        <div class="col-4">
                                            <small class="text-muted d-block">Customer</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityCustomer ||
                                                0}}</span>
                                        </div>
                                        <div class="col-4">
                                            <small class="text-muted d-block">Retailer</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityRetailer ||
                                                0}}</span>
                                        </div>
                                        <div class="col-4">
                                            <small class="text-muted d-block">Wholesaler</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityWholesaler ||
                                                0}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="card-footer bg-light d-flex justify-content-between align-items-center p-2">
                        <small class="text-muted">Last updated: {{sampleData?.updatedAt | date}}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
